import {
  faArrowDownZA,
  faArrowUpAZ,
  faCircleCheck,
  faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";

const addHeadersToExamArray = (
  examArray,
  isCaseListAscending,
  sortOrder,
  reviewLaterExams
) => {
  const examArrayCopy = structuredClone(examArray);
  switch (sortOrder) {
    case "CaseNumber":
      for (let i = 0; i < examArrayCopy.length; ++i) {
        if (i % 11 === 0 && i + 9 < examArrayCopy.length) {
          examArrayCopy.splice(i, 0, {
            type: "logoText",
            text: "Exam Number",
            headerText: `${examArrayCopy[i].examNumber} - ${
              examArrayCopy[i + 9].examNumber
            }`,
          });
          i += 1;
        } else if (i % 11 === 0) {
          examArrayCopy.splice(i, 0, {
            type: "logoText",
            text: "Exam Number",
            headerText: `${examArrayCopy[i].examNumber} - ${
              examArrayCopy[examArrayCopy.length - 1].examNumber
            }`,
          });
          i += 1;
        }
      }
      break;
    case "CompletionDate":
      for (let i = 0; i < examArrayCopy.length; ++i) {
        const isExamCompleted = examArrayCopy[i].Completed;
        const isExamCompletionInvalid =
          examArrayCopy[i].MostRecentCompletionDate === "0001-01-01T00:00:00";
        const isExamCompletedAndValid =
          isExamCompleted && !isExamCompletionInvalid;

        if (i === 0) {
          examArrayCopy.splice(i, 0, {
            type: "icon",
            text: isExamCompletedAndValid
              ? "Completed Exams"
              : "Incomplete Exams",
            icon: isExamCompletedAndValid ? faCircleCheck : faCircleXmark,
          });
          if (isCaseListAscending) i += 1;
        }

        const isNextExamCompleted = examArrayCopy[i + 1]?.Completed;
        const isNextExamCompletionInvalid =
          examArrayCopy[i + 1]?.MostRecentCompletionDate ===
          "0001-01-01T00:00:00";
        const isNextExamCompletedAndValid =
          isNextExamCompleted && !isNextExamCompletionInvalid;

        if (isExamCompletedAndValid && !isNextExamCompletedAndValid) {
          examArrayCopy.splice(i + 1, 0, {
            type: "icon",
            text: "Incomplete Exams",
            icon: faCircleXmark,
          });
          break;
        }
        if (!isExamCompletedAndValid && isNextExamCompletedAndValid) {
          examArrayCopy.splice(i + 1, 0, {
            type: "icon",
            text: "Completed Exams",
            icon: faCircleCheck,
          });
          break;
        }
      }
      break;
    case "ReviewLater":
      if (examArrayCopy.length === 0) break;

      const isFirstExamMarked = reviewLaterExams[examArrayCopy[0].ExamId];
      examArrayCopy.splice(0, 0, {
        type: "icon",
        text: isFirstExamMarked ? "Review Later" : "Unmarked Exams",
        icon: isFirstExamMarked ? faCircleCheck : faCircleXmark,
      });

      for (let i = 1; i < examArrayCopy.length - 1; ++i) {
        const isExamMarked = reviewLaterExams[examArrayCopy[i].ExamId];
        const isNextExamMarked = reviewLaterExams[examArrayCopy[i + 1].ExamId];
        if (
          (!isNextExamMarked && isExamMarked) ||
          (isNextExamMarked && !isExamMarked)
        ) {
          examArrayCopy.splice(i + 1, 0, {
            type: "icon",
            text: isExamMarked ? "Unmarked Exams" : "Review Later",
            icon: isExamMarked ? faCircleXmark : faCircleCheck,
          });
          break;
        }
      }
      break;
    case "AverageGrade":
      for (let i = 0; i < examArrayCopy.length; ++i) {
        const isExamCompleted = examArrayCopy[i].Completed;
        const isExamCompletionInvalid =
          examArrayCopy[i].MostRecentCompletionDate === "0001-01-01T00:00:00";
        const isExamCompletedAndValid =
          isExamCompleted && !isExamCompletionInvalid;

        if (i === 0) {
          examArrayCopy.splice(i, 0, {
            type: "icon",
            text: isExamCompletedAndValid
              ? "Average Grade"
              : "Incomplete Exams",
            icon: isExamCompletedAndValid ? faCircleCheck : faCircleXmark,
          });
          if (isCaseListAscending) i += 1;
        }

        const isNextExamCompleted = examArrayCopy[i + 1]?.Completed;
        const isNextExamCompletionInvalid =
          examArrayCopy[i + 1]?.MostRecentCompletionDate ===
          "0001-01-01T00:00:00";
        const isNextExamCompletedAndValid =
          isNextExamCompleted && !isNextExamCompletionInvalid;

        if (isExamCompletedAndValid && !isNextExamCompletedAndValid) {
          examArrayCopy.splice(i + 1, 0, {
            type: "icon",
            text: "Incomplete Exams",
            icon: faCircleXmark,
          });
          break;
        }
        if (!isExamCompletedAndValid && isNextExamCompletedAndValid) {
          examArrayCopy.splice(i + 1, 0, {
            type: "icon",
            text: "Average Grade",
            icon: faCircleCheck,
          });
          break;
        }
      }
      break;
    case "CaseTitle":
      if (isCaseListAscending) {
        if (examArrayCopy.length > 0) {
          examArrayCopy.splice(0, 0, {
            type: "icon",
            text: "Title",
            icon: faArrowUpAZ,
          });
        }
      } else {
        if (examArrayCopy.length > 0) {
          examArrayCopy.splice(0, 0, {
            type: "icon",
            text: "Title",
            icon: faArrowDownZA,
          });
        }
      }
      break;
    default:
      break;
  }
  return examArrayCopy;
};

export default addHeadersToExamArray;
